import React from 'react';
import {
  Nav,
  NavItem,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  NavLink,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import pointsSvg from 'images/points.svg';
import EditDomainModal from 'components/EditDomainModal';

export default class DropdownDomainCard extends React.Component {
  state = {
    dropdownOpen: false,
  };

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    const { isMenuOpen } = this.state;
    const {
      handleDelete,
      handleEdit,
      toggleModalEdit,
      toggleModalDelete,
      editableShortcode,
      nonDeletable,
    } = this.props;

    return (
      <Nav className="domain-card__drop">
        <Dropdown
          nav
          isOpen={this.state.dropdownOpen}
          toggle={this.toggleDropdown}>
          <DropdownToggle nav caret>
            <img src={pointsSvg} alt="" />
          </DropdownToggle>
          <DropdownMenu>
            {editableShortcode && (
              <p className="domain-drop__link" onClick={toggleModalEdit}>
                Edit domain
              </p>
            )}
            {!nonDeletable && (
              <p
                className="domain-drop__link color-red"
                onClick={toggleModalDelete}>
                Delete domain
              </p>
            )}
            {nonDeletable && !editableShortcode && (
              <p className="domain-drop__link">No actions avaliable</p>
            )}
          </DropdownMenu>
        </Dropdown>
      </Nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DomainCard/DropdownDomainCard.js